/*
 * Navegación del sistema (shell). Fuente única para el menú, el título de
 * sección y las pruebas.
 *
 * sections: lo que se usa a diario, siempre visible y a un clic. Siguen el
 *   recorrido de un trabajo: llega el auto (Taller), se compran refacciones,
 *   se cobra y se factura; Reportes cierra el ciclo. El título de la sección
 *   solo agrupa, no se pulsa.
 * groups: lo que se modifica pocas veces al mes o menos. Van en submenú
 *   cerrado (acordeón).
 * Citas y Gastos siguen en el router, fuera del menú: el taller no las usa.
 * Sucursales también: se ocultó porque la pantalla no funciona del todo.
 */
export const sections = [
  {
    id: 'inicio',
    items: [{ name: 'inicio', path: '/menu', label: 'Inicio', icon: 'home' }],
  },
  {
    id: 'taller',
    label: 'Taller',
    items: [
      { name: 'orden', path: '/menu/orden', label: 'Órdenes de servicio', icon: 'clipboard' },
      // exact: false -> sigue activo en el expediente (/menu/historial/:vehiculo)
      { name: 'historial', path: '/menu/historial', label: 'Historial', icon: 'clock', exact: false },
      { name: 'clientes', path: '/menu/catalogo/clientes', label: 'Clientes', icon: 'users' },
    ],
  },
  {
    id: 'refacciones',
    label: 'Refacciones',
    items: [
      { name: 'compras', path: '/menu/catalogo/compras', label: 'Compras', icon: 'truck' },
      { name: 'inventario', path: '/menu/catalogo/inventario', label: 'Inventario', icon: 'boxes' },
    ],
  },
  {
    id: 'cobro',
    label: 'Cobro',
    items: [
      // exact: false -> sigue activo en /menu/venta/:orden
      { name: 'venta', path: '/menu/venta', label: 'Punto de venta', icon: 'cart', exact: false },
      { name: 'ventas', path: '/menu/catalogo/ventas', label: 'Ventas', icon: 'receipt' },
      { name: 'facturas', path: '/menu/catalogo/facturas', label: 'Facturas', icon: 'document' },
    ],
  },
  {
    id: 'reportes',
    items: [{ name: 'reportes', path: '/menu/reportes', label: 'Reportes', icon: 'chart' }],
  },
]

export const topItems = sections.flatMap((section) => section.items)

export const groups = [
  {
    id: 'catalogos',
    label: 'Catálogos',
    icon: 'folder',
    items: [
      { name: 'servicios', path: '/menu/catalogo/servicios', label: 'Servicios', icon: 'wrench' },
      { name: 'productos', path: '/menu/catalogo/productos', label: 'Productos', icon: 'tag' },
      { name: 'modelos', path: '/menu/catalogo/modelos', label: 'Modelos', icon: 'tag' },
      { name: 'marcas', path: '/menu/catalogo/marcas', label: 'Marcas', icon: 'tag' },
      { name: 'proveedores', path: '/menu/catalogo/proveedores', label: 'Proveedores', icon: 'building' },
    ],
  },
  {
    id: 'administracion',
    label: 'Administración',
    icon: 'cog',
    items: [
      { name: 'empleados', path: '/menu/catalogo/empleados', label: 'Empleados', icon: 'users' },
      { name: 'usuarios', path: '/menu/catalogo/usuarios', label: 'Usuarios', icon: 'lock' },
    ],
  },
]

const extraLabels = {
  ventaConOrden: 'Punto de venta',
  historialVehiculo: 'Historial',
  gastos: 'Gastos',
  citas: 'Citas',
  catalogo: 'Catálogos',
  sucursal: 'Sucursales',
}

export const allItems = [...topItems, ...groups.flatMap((group) => group.items)]

export function groupForRoute(name) {
  return groups.find((group) => group.items.some((item) => item.name === name))
}

export function labelForRoute(name) {
  const item = allItems.find((i) => i.name === name)
  if (item) return item.label
  return extraLabels[name] || name || 'Inicio'
}
